<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-22 10:54:30
 * @FilePath: \mrc-ess-base-frontend\src\components\mrc_ess_dateTimePicker\mrc_ess_dateTimePicker.vue
 * @最后编辑: Betway
 * @最后修改时间: 2023-01-10 15:38:52
--> 
<template>
  <v-menu
    ref="menu"
    v-model="showMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    :return-value.sync="datetime"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      {{ label }}
      <v-text-field
        v-model="datetime"
        readonly
        v-bind="attrs"
        v-on="filled ? on : null"
        :rules="rules"
        :hide-details="hideDetail"
        :placeholder="label"
        :filled="filled"
        single-line
        dense
      ></v-text-field>
    </template>
    <v-card v-if="type == 'date'" class="pa-0 ma-0">
      <v-card-text class="pa-0 ma-0">
        <v-date-picker
          v-model="datetime"
          :allowed-dates="(val) => refuseDate.indexOf(val) === -1"
          no-title
          scrollable
          :locale="$store.state.lang"
          :min="min"
          :max="max"
          color="primary"
          flat
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="text-capitalize"
            @click="showMenu = false"
            small
            rounded
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5"
            rounded
            small
            @click="$refs.menu.save(datetime)"
            >OK</v-btn
          >
        </v-date-picker>
      </v-card-text>
    </v-card>
    <v-card v-if="type == 'month'" class="pa-0 ma-0">
      <v-card-text class="pa-0 ma-0">
        <v-date-picker
          v-model="datetime"
          no-title
          scrollable
          :locale="$store.state.lang"
          type="month"
          color="primary"
          flat
        >
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="text-capitalize"
            @click="showMenu = false"
            small
            rounded
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5"
            rounded
            small
            @click="$refs.menu.save(datetime)"
            >OK</v-btn
          >
        </v-date-picker>
      </v-card-text>
    </v-card>
    <v-card v-if="type == 'time'" class="pa-0 ma-0">
      <v-card-text class="pa-0 ma-0">
        <v-sheet class="d-flex flex-row justify-space-arounnd pa-0">
          <TimeWidget
            @change="
              (time) => {
                datetime = time;
              }
            "
            :defaultTime="0"
          />
        </v-sheet>
        <v-sheet class="d-flex pa-3">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="text-capitalize"
            @click="onCancel"
            small
            rounded
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5"
            rounded
            small
            @click="$refs.menu.save(datetime)"
            >OK</v-btn
          >
        </v-sheet>
      </v-card-text>
    </v-card>
    <v-card v-if="type == 'datetime'" class="pa-0 ma-0">
      <v-card-text class="pa-0 ma-0">
        <v-sheet class="d-flex flex-row justify-space-arounnd pa-0">
          <Taber
            :curTab="curTab"
            @change="(tab) => (curTab = tab)"
            :items="taber"
            backgroundColor="white"
            :grow="false"
            :centered="false"
          >
            <template v-slot:content-1>
              <v-date-picker
                v-model="DateTime.Date"
                no-title
                :locale="$store.state.lang"
                scrollable
                color="primary"
                :max="getMaxMin('maxdate')"
                :min="getMaxMin('mindate')"
                flat
              ></v-date-picker>
            </template>
            <template v-slot:content-2>
              <TimeWidget
                @change="
                  (time) => {
                    DateTime.Time = time;
                  }
                "
                :max="getMaxMin('maxtime')"
                :min="getMaxMin('mintime')"
              />
            </template>
          </Taber>
        </v-sheet>
        <v-sheet class="d-flex pl-3 pr-3 pb-3">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="text-capitalize"
            @click="onCancel"
            small
            rounded
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5"
            rounded
            small
            @click="$refs.menu.save(DateTime.Date + ' ' + DateTime.Time)"
            >OK</v-btn
          >
        </v-sheet>
      </v-card-text>
    </v-card>
    <v-card v-if="type == 'daterange'" class="pa-0 ma-0">
      <v-card-text class="pa-0 pb-3 ma-0">
        <v-sheet
          class="d-flex flex-row justify-space-arounnd pa-3"
          height="300"
        >
          <v-date-picker
            v-model="SEDate.StartDate"
            no-title
            scrollable
            :locale="$store.state.lang"
            color="primary"
            flat
            :max="SEDate.EndDate"
          ></v-date-picker>
          <!--  @change="(val)=>{if(SEDate.EndDate){datetime=val+'~~'+SEDate.EndDate}}" -->
          <div
            class="fill-height d-flex align-center text-center flex-grow-1"
            style="width: 15px"
          >
            <v-divider
              vertical
              style="border-color: var(--main-color); margin-left: 7.5px"
            ></v-divider>
            <v-sheet class="border_style"></v-sheet>
          </div>
          <v-date-picker
            v-model="SEDate.EndDate"
            no-title
            :locale="$store.state.lang"
            scrollable
            color="primary"
            flat
            :min="SEDate.StartDate"
          ></v-date-picker>
          <!--  @change="(val)=>{if(SEDate.StartDate){datetime=SEDate.StartDate+'~~'+val}}" -->
        </v-sheet>
        <v-sheet class="d-flex pl-3 pr-3">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="text-capitalize"
            @click="onCancel"
            small
            rounded
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5"
            rounded
            :disabled="!SEDate.StartDate || !SEDate.EndDate"
            small
            @click="$refs.menu.save(SEDate.StartDate + '~~' + SEDate.EndDate)"
            >OK</v-btn
          >
        </v-sheet>
      </v-card-text>
    </v-card>
    <v-card v-if="type == 'timerange'" class="pa-0 ma-0">
      <v-card-text class="pa-0 ma-0">
        <v-sheet
          class="d-flex flex-row justify-space-arounnd pa-3"
          height="320"
        >
          <TimeWidget
            @change="
              (time, minute) => {
                TimeRange.StartTime = time;
                TimeRange.StartTimeMinute = minute;
              }
            "
            :max="TimeRange.EndTimeMinute"
          />
          <div
            class="fill-height d-flex align-center text-center flex-grow-1"
            style="width: 15px"
          >
            <v-divider
              vertical
              style="border-color: var(--main-color); margin-left: 7.5px"
            ></v-divider>
            <v-sheet class="border_style"></v-sheet>
          </div>
          <TimeWidget
            showDay
            isEnd
            @change="
              (time, minute) => {
                TimeRange.EndTime = time;
                TimeRange.EndTimeMinute = minute;
              }
            "
            :min="TimeRange.StartTimeMinute"
          />
        </v-sheet>
        <v-sheet class="d-flex pa-3">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="text-capitalize"
            @click="onCancel"
            small
            rounded
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5"
            rounded
            :disabled="!TimeRange.StartTime || !TimeRange.EndTime"
            small
            @click="
              $refs.menu.save(TimeRange.StartTime + '~~' + TimeRange.EndTime)
            "
            >OK</v-btn
          >
        </v-sheet>
      </v-card-text>
    </v-card>
    <v-card v-if="type == 'datetimerange'" class="pa-0 ma-0">
      <v-card-text class="pa-0 ma-0">
        <v-sheet
          class="d-flex flex-row justify-space-arounnd pa-3"
          height="400"
        >
          <mrc_ess_taber
            :curTab="curTab"
            :items="taber"
            backgroundColor="white"
            :grow="false"
            :centered="false"
          >
            <template v-slot:content-1>
              <v-sheet
                class="d-flex flex-row justify-space-arounnd pa-0"
                height="260"
              >
                <v-date-picker
                  v-model="SEDateTime.StartDate"
                  no-title
                  scrollable
                  :locale="$store.state.lang"
                  color="primary"
                  flat
                  :max="SEDateTime.EndDate"
                ></v-date-picker>
                <div
                  class="
                    fill-height
                    d-flex
                    align-center
                    text-center
                    flex-grow-1
                  "
                  style="width: 15px"
                >
                  <v-divider
                    vertical
                    style="border-color: var(--main-color); margin-left: 7.5px"
                  ></v-divider>
                  <v-sheet class="border_style"></v-sheet>
                </div>
                <v-date-picker
                  v-model="SEDateTime.EndDate"
                  no-title
                  scrollable
                  :locale="$store.state.lang"
                  color="primary"
                  flat
                  :min="SEDateTime.StartDate"
                ></v-date-picker>
              </v-sheet>
            </template>
            <template v-slot:content-2>
              <v-sheet
                class="d-flex flex-row justify-space-arounnd pa-3"
                height="320"
              >
                <TimeWidget
                  @change="
                    (time, minute) => {
                      SEDateTime.StartTime = time;
                      SEDateTime.StartTimeMinute = minute;
                    }
                  "
                  :max="
                    SEDateTime.StartDate
                      ? SEDateTime.EndDate
                        ? SEDateTime.StartDate == SEDateTime.EndDate
                          ? SEDateTime.EndTimeMinute
                          : ''
                        : SEDateTime.EndTimeMinute
                      : SEDateTime.EndTimeMinute
                  "
                />
                <div
                  class="
                    fill-height
                    d-flex
                    align-center
                    text-center
                    flex-grow-1
                  "
                  style="width: 15px"
                >
                  <v-divider
                    vertical
                    style="border-color: var(--main-color); margin-left: 7.5px"
                  ></v-divider>
                  <v-sheet class="border_style"></v-sheet>
                </div>
                <TimeWidget
                  isEnd
                  @change="
                    (time, minute) => {
                      SEDateTime.EndTime = time;
                      SEDateTime.EndTimeMinute = minute;
                    }
                  "
                  :min="
                    SEDateTime.StartDate
                      ? SEDateTime.EndDate
                        ? SEDateTime.StartDate == SEDateTime.EndDate
                          ? SEDateTime.StartTimeMinute
                          : ''
                        : SEDateTime.StartTimeMinute
                      : SEDateTime.StartTimeMinute
                  "
                />
              </v-sheet>
            </template>
          </mrc_ess_taber>
        </v-sheet>
        <v-sheet class="d-flex pa-3">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="primary"
            class="text-capitalize"
            @click="onCancel"
            small
            rounded
            >Cancel</v-btn
          >
          <v-btn
            color="primary"
            class="text-capitalize pl-5 pr-5"
            rounded
            :disabled="!SEDateTime.StartDate || !SEDateTime.EndDate"
            small
            @click="
              $refs.menu.save(
                SEDateTime.StartDate +
                  ' ' +
                  SEDateTime.StartTime +
                  '~~' +
                  SEDateTime.EndDate +
                  ' ' +
                  SEDateTime.EndTime
              )
            "
            >OK</v-btn
          >
        </v-sheet>
      </v-card-text>
    </v-card>
  </v-menu>
</template>
<script>
import TimeWidget from "./TimeWidget";
import Taber from "./taber";
import moment from "moment";
export default {
  name: "NewDateTimePicker",
  components: { TimeWidget, Taber },
  props: {
    placeholder: { default: "", type: String },
    max: { default: "", type: String },
    min: { default: "", type: String },
    rules: {
      default: function () {
        return [];
      },
      type: Array,
    },
    filled: { default: true, type: Boolean },
    defaultTime: { default: "", type: String },
    hideDetail: { default: false, type: Boolean },
    label: { default: "", type: String },
    refuseDate: {
      default: function () {
        return [];
      },
      type: Array,
    },
    type: {
      default: "",
      type: String,
      required: true,
      validator: function (value) {
        return (
          [
            "date",
            "time",
            "month",
            "datetime",
            "daterange",
            "timerange",
            "datetimerange",
          ].indexOf(value) !== -1
        );
      },
    },
  },
  data() {
    return {
      showMenu: false,
      datetime: "",
      curTab: "tab-1",
      taber: ["Date", "Time"],
      SEDateTime: {
        StartDate: "",
        EndDate: "",
        StartTime: "00:00",
        StartTimeMinute: 0,
        EndTime: "00:00",
        EndTimeMinute: 0,
      },
      SEDate: { StartDate: "", EndDate: "" },
      DateTime: { Date: "", Time: "00:00" },
      TimeRange: {
        StartTime: "",
        StartTimeMinute: 0,
        EndTime: "",
        EndTimeMinute: 0,
      },
    };
  },
  watch: {
    time(val) {
      this.DateTime.Time = val;
    },
    datetime(val) {
      this.$emit("change", val, this.type);
    },
    defaultTime(val) {
      // console.log(val);
      this.datetime = val;
      this.$refs.menu.save(val);
    },
  },
  mounted() {
    this.datetime = this.defaultTime;
    this.$refs.menu.save(this.defaultTime);
  },
  methods: {
    onCancel: function () {
      this.SEDate = {
        StartDate: this.$refs.menu.returnValue.split("~~")[0],
        EndDate: this.$refs.menu.returnValue.split("~~")[1],
      };
      this.datetime = this.$refs.menu.returnValue;
      this.showMenu = false;
    },
    getMaxMin: function (type) {
      if (type == "maxdate") {
        if (!this.max) {
          return "";
        } else {
          return moment(this.max).format("YYYY-MM-DD");
        }
      }
      if (type == "mindate") {
        if (!this.min) {
          return "";
        } else {
          return moment(this.min).format("YYYY-MM-DD");
        }
      }
      if (type == "mintime") {
        if (
          moment(this.min).format("YYYY-MM-DD") !=
          moment(this.max).format("YYYY-MM-DD")
        ) {
          return "";
        } else {
          if (!this.min) {
            return "";
          } else {
            return this.$timeMachine(moment(this.min).format("HH:mm"));
          }
        }
      }
      if (type == "maxtime") {
        if (
          moment(this.min).format("YYYY-MM-DD") !=
          moment(this.max).format("YYYY-MM-DD")
        ) {
          return "";
        } else {
          if (!this.min) {
            return "";
          } else {
            return this.$timeMachine(moment(this.min).format("HH:mm"));
          }
        }
      }
    },
    timeMachine: function (day, hour, minute) {
      return Number(day) * 60 * 24 + Number(hour) * 60 + Number(minute);
    },
  },
};
</script>
<style scoped>
.border_style {
  width: 8px;
  height: 8px;
  position: absolute;
  margin-left: 5px;
  border-top: 1px solid var(--main-color);
  border-right: 1px solid var(--main-color);
  background: white;
  transform: rotate(45deg);
}
</style>